import without from "lodash-es/without";

export const setSession = (key, value) => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem(key, JSON.stringify(value, null, 2));
  }
};

export const getSession = (key) => {
  if (typeof window !== "undefined") {
    const storage = sessionStorage.getItem(key);
    return storage && storage !== "undefined" ? JSON.parse(storage) : null;
  }
  return null;
};

export const setStorage = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value, null, 2));
  }
};

export const removeSessionItem = (key) => {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(key);
  }
};

export const getStorage = (key) => {
  if (typeof window !== "undefined") {
    const storage = localStorage.getItem(key);
    return storage && storage !== "undefined" ? JSON.parse(storage) : null;
  }
  return null;
};

export const clearStorageItem = (key) => {
  if (typeof window !== "undefined") {
    if (localStorage) {
      localStorage.removeItem(key);
    }
  }
};
export const clearStorage = (list) => {
  if (typeof window !== "undefined") {
    if (localStorage && list?.length > 0) {
      list.forEach(key => localStorage.removeItem(key));
    }
  }
};

export const clearStorageAll = (excludeList) => {
  if (typeof window !== "undefined") {
    if (localStorage) {
      let keys = Object.keys(localStorage);
      if (excludeList && excludeList?.length > 0) {
        keys = without(keys, ...excludeList);
      }
      keys.forEach(key => {
        localStorage.removeItem(key);
      });
    }
  }
};
export const setExpire = (key, value, expire) => {
  if (typeof window !== "undefined") {
    const obj = {
      data: value,
      time: Date.now(),
      expire: expire,
    };
    localStorage.setItem(key, JSON.stringify(obj));
  }
};
export const getExpire = key => {
  if (typeof window !== "undefined") {
    let storage = localStorage.getItem(key);
    if (!storage) {
      return storage;
    }
    storage = JSON.parse(storage);
    if (Date.now() - storage.time > storage.expire) {
      localStorage.removeItem(key);
      return null;
    }
    return storage.data;
  }
  return null;
};


export const getWebgainsTrackNoBySession = () => {
  if (typeof window !== "undefined") {
    const storage = window?.sessionStorage.getItem("WEBGAINS_TRACK_ID");
    return storage || null;
  }
};

export const setWebgainsTrackNoBySession = (value) => {
  if (typeof window !== "undefined") {
    window?.sessionStorage?.setItem("WEBGAINS_TRACK_ID", value);
  }
};

export const getWebgainsTrackProviderBySession = () => {
  if (typeof window !== "undefined") {
    const storage = window?.sessionStorage.getItem("WEBGAINS_TRACK_PROVIDER");
    return storage || null;
  }
};

export const setWebgainsTrackProviderBySession = (value) => {
  if (typeof window !== "undefined") {
    window?.sessionStorage?.setItem("WEBGAINS_TRACK_PROVIDER", value);
  }
};

/** 设置第三方平台来源 */
export const setPlatformSourceBySession = (value) => {
  if (typeof window !== "undefined") {
    window?.sessionStorage?.setItem("PLATFORM_SOURCE", value);
  }
};

/** 获取第三方平台来源 */
export const getPlatformSourceBySession = () => {
  if (typeof window !== "undefined") {
    const storage = window?.sessionStorage?.getItem("PLATFORM_SOURCE");
    return storage || null;
  }
};

/** 清空三方登录授权码 */
export const removeOtherLogin = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("FB_CODE");
    localStorage.removeItem("FB_STATE");
    localStorage.removeItem("GOOGLE_CODE");
    localStorage.removeItem("GOOGLE_STATE");
    localStorage.removeItem("APPLE_CODE");
    localStorage.removeItem("APPLE_STATE");
    localStorage.removeItem("APPLE_TOKEN");
    localStorage.removeItem("PLATFORM");
    localStorage.removeItem("socialUid");
  }
};
